module.exports = __webpack_public_path__ + "static/assets/bd466745e237d2ca023d6c21ed53498f.svg";